import React, { FC, useEffect, useState } from "react";
import LandingCallToAction from "@/features/landing/components/CallToAction";
import ctaImage from "../../../src/features/landing/assets/elgRacing.webp";
import { getChallengeBasedOnClient } from "../../../branchAndBrandSpecific/helperFunctions/getChallengeBasedOnClient";
import { clientAtom } from "@/utils/atoms/atomClient";
import { useAtom } from "jotai";

const RacingPartnerPage: FC = (): JSX.Element => {
  const [challengeLink, setChallengeLink] = useState<string>("");
  const [client, setCurrentClient] = useAtom(clientAtom);
  setCurrentClient("ELGIGANTEN");

  // Fetch current active challenge logic
  const fetch = async () => {
    await getChallengeBasedOnClient(client, "ongoing").then((res) => {
      if (res.slug) {
        setChallengeLink(`/challenges/${res.slug}`);
      }
    });
  };

  // Fetch current active challenge on page load
  useEffect(() => {
    if (client) {
      fetch();
    }
  }, [client]);

  return (
    <div className="partner">
      <LandingCallToAction
        title={"F1® 23  Challenge"}
        desc={
          "Set the best lap time and test your racing skills and set the fastest time in our F1® 23 challenge. Try the award-winning Logitech G design. The TRUEFORCE feedback technology reacts directly to the events in the game and ensures unprecedented realism."
        }
        image={ctaImage}
        link={challengeLink}
        label={challengeLink !== "" ? "Join the challenge" : ""}
        float="left"
      />
    </div>
  );
};

export default RacingPartnerPage;
